export default {
  LEADS_OVERVIEW: 'Presentatie van de vooruitzichten',
  TOTAL_LEADS: 'Aantal totale vooruitzichten',
  HOT_LEADS: 'Pistas calientes',
  WARM_LEADS: 'Des pistas chaleureuses',
  COLD_LEADS: 'De pistas de froides',
  NO_RECORDS_FOUND: 'Aucun inschrijving trouvé',
  DETAILS: 'Detalles',
  CATEGORY: 'categoría',
  SCAN_DATE_N_TIME: 'Fecha en hora de numeración',
  FILTER: 'filtrar',
  ALL: 'Aan ons',
  HOT: 'chaud',
  WARM: 'chaud',
  COLD: 'froide',
  SELECT_DATES: 'seleccionar fechas',
  SEARCH_LEADS: 'clientes potenciales de búsqueda',
  SCANNED_BY: 'escaneado por',
  FILES_INFO_SHARED: 'Archivos e información compartidos.',
  IMAGES: 'Imágenes',
  NOTE: 'Nota',
  DELETED_FILE_MSG: 'Este archivo ha sido eliminado.',
  LEAD_DETAILS: 'Detalles del cliente potencial',
  ANONYMISE_DAYS: 'Los datos de los clientes potenciales se anonimizarán en {days} días.'
}
